import React, { useEffect, useState } from "react";
import api, { BRAND } from "@/lib/appApi";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";

export default function AgeGate({ onPass, onExit }) {
  const [geo, setGeo] = useState({ country: null, min_age: 18 });

  useEffect(() => {
    api.get("/geo").then((r) => setGeo(r.data)).catch(() => setGeo({ country: null, min_age: 18 }));
  }, []);

  const confirm = () => {
    localStorage.setItem("age_confirmed", "true");
    onPass();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 glass" data-testid="age-gate">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-8 text-center shadow-2xl">
        <img src={BRAND.logo} alt="logo" className="w-14 h-14 rounded-full mx-auto mb-4" />
        <div className="inline-flex items-center gap-2 text-destructive mb-3">
          <ShieldAlert className="w-5 h-5" />
          <span className="font-heading font-bold text-sm uppercase tracking-wide">Adult content warning</span>
        </div>
        <h2 className="font-heading text-2xl font-extrabold">This is an 18+ website</h2>
        <p className="text-sm text-muted-foreground mt-3">
          Random Cam Chat may contain sexually explicit material. You must be an adult to enter.
          {geo.country && (
            <> Based on your location (<span className="text-foreground font-medium">{geo.country}</span>), you must be at least{" "}
            <span className="brand-gradient-text font-bold">{geo.min_age}</span> years old.</>
          )}
        </p>
        <div className="mt-6 flex flex-col gap-3">
          <Button onClick={confirm} data-testid="age-confirm-btn"
            className="brand-gradient-bg text-white border-0 rounded-full h-11 font-semibold transition-transform hover:scale-105">
            I am {geo.min_age}+ · Enter
          </Button>
          <Button variant="ghost" onClick={onExit} data-testid="age-exit-btn" className="text-muted-foreground">
            Leave
          </Button>
        </div>
      </div>
    </div>
  );
}
